import { createFileRoute } from "@tanstack/react-router";
import { SiteDetails } from "@/components/sites/details";

export const Route = createFileRoute(
  "/dashboard/_admin/company/$companyId/sites/$siteId",
)({
  component: RouteComponent,
  staticData: {
    title: "Asset Details",
    parent: { title: "Company Management", path: "/dashboard/company" },
  },
});

function RouteComponent() {
  const { siteId, companyId } = Route.useParams();

  return <SiteDetails siteId={siteId} companyId={companyId} />;
}
